export const socketAPI = process.env.SOCKETAPI
// export const baseAPI = 'http://localhost:4000/'
export const baseAPI = process.env.BASEAPI
export const privacyTitle = '個人資料蒐集/處理/利用告知聲明暨同意書'
